// @flow
import { connect } from "react-redux";
import Dialog from "./view";

export default connect(() => ({}))(Dialog);



// WEBPACK FOOTER //
// ./src/dialog/index.js